import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetPublicCalculationsQuery, useGetPublicCalculatorOfferingQuery } from '@app/api/publicCalculatorApi';
import LOCALE from '@app/configs/locale';
import LoanCalculator from '@modules/calculator/components/LoanCalculator';
const DemoCalculator = () => {
    const { i18n } = useTranslation();
    const [searchParams] = useSearchParams();
    useEffect(() => {
        const localeParam = searchParams.get('locale');
        if (localeParam && LOCALE.LOCALES.includes(localeParam) && i18n.language !== localeParam) {
            i18n.changeLanguage(localeParam);
        }
    }, [searchParams, i18n]);
    return (<div className="min-h-screen w-full bg-white p-6">
            <LoanCalculator isDemo useOfferingQuery={useGetPublicCalculatorOfferingQuery} useCalculationsQuery={useGetPublicCalculationsQuery}/>
        </div>);
};
export default DemoCalculator;
